export default __webpack_public_path__ + "static/media/AboutSlide1.a923eddb.jpg";